import React, { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Box from '@mui/material/Box'

import { selectPage, selectPageIsMine } from '../pages/pagesSlice'
import { createStikiAsync } from './stikisSlice'
import { selectUIColorCurrent } from '../ui/uiSlice'

import { clamp } from '../../helpers'

import {
  STIKI_DEFAULT_WIDTH,
  STIKI_MAX_LEFT_EDGE,
  STIKI_MAX_TOP_EDGE,
  STIKI_MIN_HEIGHT,
  STIKI_MIN_LEFT_EDGE,
  STIKI_MIN_TOP_EDGE,
} from '../../constants'

const classes = {
  root: {
    '& .createStikiText': {
      // #createStikiText {
      backgroundColor: 'rgb(240, 230, 140)',
      width: '65%',
      fontSize: '16px',
    },
    '& .testHeight': {
      position: 'fixed',
      visibility: 'hidden',
      left: '10px',
      top: '110%',
      width: '13em',
      wordSpacing: '0.5px',
      wordWrap: 'break-word',
      lineHeight: '1.231',
      backgroundColor: 'silver',
      border: '1px solid black',
      textAlign: 'left',
    },
    '& .submitCreateStiki': {
      // #submitCreateStiki {
      width: '25%',
      fontSize: '14px',
      overflow: 'hidden',
    },
  },
}

function jitter(amount) {
  var direction = Math.round(Math.random()) * 2 - 1
  return direction * (amount * Math.random())
}

export default function AddStiki(props) {
  const pageId = props.pageId
  const page = useSelector(selectPage(pageId))
  // No adding stikis to a page someone shared with me.
  const isMine = useSelector(selectPageIsMine(pageId))

  const currentColor = useSelector(selectUIColorCurrent)

  const dispatch = useDispatch()
  const [text, setText] = useState('')

  const testHeight = useRef(null)

  const stikiData = () => {
    const left_edge = clamp(
      jitter(20) - STIKI_DEFAULT_WIDTH / 2 - page.left_edge,
      STIKI_MIN_LEFT_EDGE,
      STIKI_MAX_LEFT_EDGE
    )
    const top_edge = clamp(
      jitter(2) - page.top_edge,
      STIKI_MIN_TOP_EDGE,
      STIKI_MAX_TOP_EDGE
    )

    // Get height of testText and divide by 18 to get number of lines.
    // Add 1.
    // Add 2 for margin.
    // Allow for 1.231 line-height
    // Not less than min height.
    let { height } = testHeight.current.getBoundingClientRect()
    height = 1.231 * (height / 18 - 1) + 3
    height = Math.max(STIKI_MIN_HEIGHT, height)
    // console.log('height:', height)

    return {
      page_id: pageId,
      stiki: {
        text,
        left_edge,
        top_edge,
        width: STIKI_DEFAULT_WIDTH,
        height,
        z_index: 'front',
        color: currentColor,
      },
    }
  }

  const handleChange = (e) => {
    // console.log('<AddStiki />.handleChange()')
    setText(e.target.value)
  }

  const handleClick = (e) => {
    // console.log('<AddStiki />.handleClick()')
    setText('')
    dispatch(createStikiAsync(stikiData()))
  }

  if (!isMine) {
    return null
  }

  return (
    <Box sx={classes.root}>
      <input
        className='createStikiText'
        type='text'
        value={text}
        placeholder='Type text for stiki...'
        style={{ backgroundColor: currentColor }}
        onChange={(e) => handleChange(e)}
      ></input>
      <span> </span>
      <button
        className='submitCreateStiki'
        aria-label='Create stiki'
        onClick={(e) => handleClick(e)}
      >
        Create
      </button>
      <div className='testHeight' ref={testHeight}>
        {text}
      </div>
    </Box>
  )
}
